import script from "./ProductView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductView.vue?vue&type=script&setup=true&lang=ts"

import "./ProductView.vue?vue&type=style&index=0&id=59383fdd&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59383fdd"]])

export default __exports__